import React, { useState, useEffect, useRef } from "react";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { RiCloseLine } from "react-icons/ri";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Link, useLocation } from "react-router-dom";
import "./navbar.css";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Nav = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Our Works",
    path: "/works",
  },
  {
    title: "Our Services",
    path: "/services",
  },
  {
    title: "Our Team",
    path: "/teams",
  },
  {
    title: "Contact",
    path: "/contact",
  },
];

const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const hamburgermenuRef = useRef();
  const [isOpen, setOpen] = useState(false);

  //to close the navbar once desired route is achieved
  const handleLinkClick = () => {
    setOpen(false);
  };

  const preventScroll = (e) => e.preventDefault();

  // Handle scroll block when the menu is open
  useEffect(() => {
    // Prevent scrolling when the menu is open
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Disable body scroll
      document.documentElement.style.overflow = "hidden"; // Also disable html scroll
      // Optional: prevent touch or mouse wheel scrolling
      window.addEventListener("wheel", preventScroll, { passive: false });
      window.addEventListener("touchmove", preventScroll, { passive: false });
    } else {
      document.body.style.overflow = ""; // Restore scrolling
      document.documentElement.style.overflow = "";
      // Clean up event listeners when menu closes
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
    }

    // Cleanup on component unmount or if isOpen changes
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      window.removeEventListener("wheel", preventScroll);
      window.removeEventListener("touchmove", preventScroll);
    };
  }, [isOpen]);

  useGSAP(() => {
    if (isOpen) {
      gsap.from(hamburgermenuRef.current.children, {
        opacity: 0,
        x: 60,
        stagger: 0.1,
        duration: 0.5,
      });
    }
  }, [isOpen]);

  return (
    <main>
      <div id="navbar" className="navbar_main">
        <div className="nav_container">
          <div className="lab_navbar_logo">
            <Link to="/">
              <img id="brand_logo" src="logo.png" alt="logolab logo" />
            </Link>
          </div>
          <div className="nav_items">
            {Nav.map((data, index) => (
              <div key={index}>
                <Link
                  to={data.path}
                  className={`nav-link relative py-2 px-1 transition-all duration-300 ${
                    currentPath === data.path
                      ? "text-white font-semibold active-nav-link"
                      : "text-lighttext hover:text-gray-300"
                  }`}
                >
                  {data.title}
                  {currentPath === data.path && (
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#E10B7B] transform scale-x-100 origin-left transition-transform duration-300"></span>
                  )}
                </Link>
              </div>
            ))}
          </div>

          <div className="whatsapp_btn_container">
            <a
              href="https://wa.me/9765978888"
              className="main_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon className="whatsapp_icon" />
              WhatsApp Us
            </a>
          </div>

          <div className="lg:hidden cursor-pointer">
            {isOpen ? (
              <RiCloseLine
                color="white"
                size={27}
                onClick={() => setOpen(!isOpen)}
              />
            ) : (
              <HiOutlineMenuAlt3
                color="white"
                size={27}
                onClick={() => setOpen(!isOpen)}
              />
            )}
          </div>
        </div>
      </div>

      <>
        <div
          className={`${
            isOpen ? "absolute lg:hidden" : "hidden"
          } left-1/2 -translate-x-1/2 top-0 w-full h-screen bg-black static z-10`}
        >
          <div className="cancel_icon float-right mt-3 mr-16">
            <div className="lg:hidden cursor-pointer">
              {isOpen ? (
                <RiCloseLine
                  color="white"
                  size={27}
                  onClick={() => setOpen(!isOpen)}
                />
              ) : (
                <HiOutlineMenuAlt3
                  color="white"
                  size={27}
                  onClick={() => setOpen(!isOpen)}
                />
              )}
            </div>
          </div>
          <div
            className="flex justify-center items-center flex-col place-items-center gap-10 my-auto absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50"
            ref={hamburgermenuRef}
          >
            {Nav.map((data, index) => (
              <div key={index} className="text-2xl">
                <Link
                  to={data.path}
                  className={`relative py-1 transition-all duration-300 ${
                    currentPath === data.path
                      ? "text-white font-bold mobile-active-nav"
                      : "text-lighttext"
                  }`}
                  onClick={handleLinkClick}
                >
                  {data.title}
                  {currentPath === data.path && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-green-500"></span>
                  )}
                </Link>
              </div>
            ))}

            <a
              href="https://wa.me/9765978888"
              className="border-2 border-green-500 flex whitespace-nowrap rounded-full px-5 py-2 my-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsAppIcon className="whatsapp_icon text-2xl text-green-500" />
              WhatsApp Us
            </a>
          </div>
        </div>
      </>
    </main>
  );
};

export default Navbar;
